require("../../node_modules/hammerjs/hammer.min.js");
require("../../node_modules/reflex_libs/src/lib/shape.js");
require("../../node_modules/reflex_libs/src/lib/pixi-spine.js");
require("../../node_modules/reflex_libs/src/lib/gsap.min.js");
require("./LoaderController.js");
require("./game.js");
require("./CascadingReels/spinFunctions.js");
require("./CascadingReels/cascadeInfiniReels.js");
require("./CascadingReels/gameReelManager.js");
require("./CascadingReels/gameSlotMachine.js");
require("./GameWinlineAnimationController.js");
require("./gameController.js");
require("./ParticleController.js");
require("./Feature/FreeSpins/freespinsController.js");
require("./Feature/FreeSpins/FreeSpinsSpinButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsSkipButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsDialogView.js");
require("./Feature/GambleSpin/GambleToggleView.js");
require("./GameHelpers.js");
require("../../node_modules/reflex_libs/src/lib/screenDimObject.js");
require("../../node_modules/reflex_libs/src/lib/screenshotAnimator.js");
require("./SymbolAnimatorController.js");
require("./SymbolWinBorderAnimController.js");
require("./WinlineFadeAnimatorView.js");
require("./CascadingReels/dropSymbolAnimator.js");
require("./Feature/GambleSpin/GambleIntroView.js");
require("./Feature/GambleSpin/GambleDisclaimerComponent.js");
require("./Feature/GambleSpin/GambleSpinController.js");
require("./AudioController.js");
require("./ShowReelView.js");
require("./CascadingReels/popAndFlyManager.js");
require("./UI/GameSlamStopButtonComponent.js");
require("./BigWinController.js");
require("../../node_modules/reflex_libs/src/lib/colourBox.js");
require("./Feature/GambleSpin/ArrowComponent.js");
require("../../node_modules/reflex_libs/src/lib/shape.js");
require("./Animations/LanternAnimationView.js");
require("./UI/LuckyBetToggleController.js");
require("./Feature/FreeSpins/FreeSpinsMeterComponent.js");
require("../../node_modules/reflex_libs/src/lib/spine.js");
require("./MessagePopperView.js");
require("./UI/StakeMinusButtonComponent.js");
require("./UI/StakePlusButtonComponent.js");
require("./MessageBoxController.js");
require("./WinlineBatcherLowWinController.js");
require("./WinTextController.js");
require("./BuyBonus/BuyBonusButtonComponent.js");
require("./BuyBonus/BuyBonusPopupView.js");
require("./UI/GameSkipWinsButtonComponent.js");
require("./UI/SettingsMenuController.js");
require("./UI/SettingsMenuButtonComponent.js");
require("./wildSymbolAnimator.js");
require("./ScrollContainer.js");
require("../../node_modules/reflex_libs/src/lib/gsapPixiPlugin.js");

//Setting Menu Buttons
require("./SystemSettings/SystemSettingVolumeButtonComponent.js");
require("./SystemSettings/SystemSettingsButtonComponent.js");
require("./SystemSettings/SystemSettingsCloseComponent.js");
require("./SystemSettings/SystemSettingsIntroScreenButtonComponent.js");
require("./SystemSettings/SystemSettingsSoundsComponents.js");
require("./SystemSettings/SystemSettingsBoxView.js");
require("./UI/settingSound.js");

//Stake/Bet Menu
require("./StakeSettings/stakeSelectionPopup_ext.js");

//Autoplay
require("./AutoplaySettings/autoplayManager-ext.js");

//Menubar
require("./SideMenu/SideMenuCloseComponent.js");
require("./SideMenu/SideMenuHelpComponent.js");
require("./GameRecoveryController.js");

//CCP Stuff
require("./TopReel.js");
